'use client'

import React, { useRef } from 'react'
import { useEnhanceRawEmbeds } from '@/components/ui/sandboxed-html-embed'

type BlogArticleBodyProps = {
  className?: string
  html: string
}

export function BlogArticleBody({ className, html }: BlogArticleBodyProps) {
  const articleRef = useRef<HTMLElement>(null)
  useEnhanceRawEmbeds(articleRef)

  return (
    <article
      ref={articleRef}
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
